import { jsxs as e, jsx as o } from "react/jsx-runtime";

import { forwardRef as t, memo as l } from "react";

import { createPortal as r } from "react-dom";

import n from "../../hooks/useId/index.js";

import s from "../../hooks/useModalHandle/index.js";

import a from "../../utils/classNames/index.js";

import d from "./Header/index.js";

const i = {
    m: "w-[500px] max-w-[90vw]",
    l: "w-[700px] max-w-[90vw]",
    custom: ""
}, c = {
    default: "",
    centered: "text-center"
}, m = {
    default: "auto-cols-fr",
    centered: "place-content-center",
    right: "place-content-end"
}, f = ({softClose: e}) => o("button", {
    type: "button",
    className: "btn btn-neutral",
    onClick: e,
    children: "Close"
}), p = l(t((({opened: t, label: l, children: p, id: u, className: x, renderPropsOptions: b, contentVariant: h = "default", footerVariant: w = "default", role: C = "dialog", size: g = "m", footer: v = f, onCustomClose: y, showHeaderCloseButton: N = !0, portal: j = !1, ...k}, H) => {
    const B = n(u), {innerRef: I, softClose: P, close: V, onCancelFinal: $} = s({
        ref: H,
        onCustomClose: y,
        opened: t
    }), z = `${B}l`, F = {
        ...b,
        close: V,
        softClose: P,
        idPrefix: `${B}c:`
    }, M = e("dialog", {
        ...k,
        onCancel: $,
        role: C,
        "aria-labelledby": z,
        className: a("max-h-[95vh] flex-col overflow-auto rounded-2xl bg-white p-0 text-neutral-600 shadow-lg open:flex sm:overflow-hidden", i[g], x),
        ref: I,
        children: [ o(d, {
            label: l,
            labelId: z,
            close: P,
            showCloseButton: N
        }), o("div", {
            className: a("typography-body px-s sm:px-m pb-s sm:pb-m leading-5 sm:overflow-auto sm:leading-6", c[h]),
            children: "function" == typeof p ? p(F) : p
        }), o("div", {
            className: a("py-s px-m gap-s relative grid shrink-0 grid-flow-col border-t border-neutral-300 bg-neutral-100", m[w]),
            children: "function" == typeof v ? v(F) : v
        }) ]
    });
    return j ? r(M, document.body) : M;
})));

export { p as default };
//# sourceMappingURL=index.js.map
